if (!customElements.get('wb-review-carousel')) {
  customElements.define('wb-review-carousel', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.index = 1;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      try {
        const response = await fetch(this.dataset.source, {signal: this.abort.signal});
        if (!response.ok) throw new Error('Review source unavailable');
        this.reviews = (await response.json()).filter(r => r.quote && r.author && r.rating >= 1 && r.rating <= 5);
        if (this.reviews.length < 3) return;
        this.cards = [...this.querySelectorAll('.wb-testimonial')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.querySelector('.wb-reviews-controls').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
        this.querySelector('[data-pause]').addEventListener('click', () => {this.paused = !this.paused;this.updatePause();}, options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => {this.index = Math.min(this.reviews.length - 1, Math.floor(this.index / 5) * 5 + i);this.render();}, options));
        this.addEventListener('keydown', e => {if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault();this.move(e.key === 'ArrowLeft' ? -1 : 1);}}, options);
        this.addEventListener('mouseenter', () => this.hovered = true, options);
        this.addEventListener('mouseleave', () => this.hovered = false, options);
        this.addEventListener('touchstart', e => this.touchX = e.touches[0].clientX, {...options,passive:true});
        this.addEventListener('touchend', e => {const delta=e.changedTouches[0].clientX-this.touchX;if(Math.abs(delta)>45)this.move(delta<0?1:-1);}, {...options,passive:true});
        this.observer = new IntersectionObserver(entries => this.visible = entries[0].isIntersecting);
        this.observer.observe(this);
        this.timer = setInterval(() => {if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.move(1);}, 6000);
        this.render();this.updatePause();
      } catch (_) { /* Keep the server-rendered reviews available when loading fails. */ }
    }
    move(step) { this.index = (this.index + step + this.reviews.length) % this.reviews.length;this.render(); }
    render() {
      this.dataset.reviewCount = this.reviews.length;
      this.dataset.reviewIndex = this.index;
      this.cards.forEach((card, i) => {
        const review = this.reviews[(this.index + i - 1 + this.reviews.length) % this.reviews.length];
        card.querySelector('blockquote').textContent = review.quote;
        card.querySelector('.wb-testimonial-name').textContent = review.author;
        card.querySelector('.wb-testimonial-product').textContent = review.product;
        const stars = card.querySelector('.wb-testimonial-stars');
        stars.setAttribute('aria-label', `${review.rating} / 5`);
        [...stars.children].forEach((star,j) => star.classList.toggle('is-empty',j>=review.rating));
      });
      this.dots.forEach((dot,i) => {dot.setAttribute('aria-current',String(i===this.index%5));dot.setAttribute('aria-label',`${Math.min(this.reviews.length,Math.floor(this.index/5)*5+i+1)} / ${this.reviews.length}`);});
    }
    updatePause() {const b=this.querySelector('[data-pause]');b.textContent=this.paused?'▶':'Ⅱ';b.setAttribute('aria-label',this.paused?b.dataset.playLabel:b.dataset.pauseLabel);}
    disconnectedCallback() {clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.started=false;}
  });
}
